<template>
  <div class="about" v-if="dd">
    <Detail msg="Welcome to Your Vue.js App" />
    <van-empty v-if="cc.length == 0" description="暂无套餐" />

    <div style="margin-top: 20px" v-if="cc.length > 0">
      <van-tabs type="card" title-style="margin: 0" animated color="#009fff">
        <van-tab
          v-for="items in cc"
          :key="items.id"
          :title="items.categoryName"
        >
          <div>
            <div
              style="position: relative"
              :class="item.isColor == 1 ? 'taocan aq' : 'taocan'"
              v-for="item in items.setMealModels"
              @click="router(item)"
              :key="item.id"
            >
              <div
                v-if="item.upRight"
                class="tuijian"
                :style="{ background: item.upRightColor }"
              >
                {{ item.upRight }}
              </div>
              <div style="display: flex; justify-content: space-between">
                <div style="width: 100%">
                  <div style="margin: 10px 0; margin-top: 15px">
                    <div
                      style="
                        text-align: left;
                        width: 100%;
                        margin-left: 5px;
                        font-size: 14px;

                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      "
                    >
                      {{ item.displayName }}
                      <!-- 特惠高速流量-月享6000G/单月-30天清零 -->
                    </div>
                  </div>

                  <div
                    style="
                      display: flex;
                      width: 100%;
                      justify-content: space-between;
                    "
                  >
                    <div style="display: flex">
                      <div style="display: flex">
                        <div class="ax">
                          流量:
                          <span v-if="item.imaginaryQuantity > 1024">
                            {{
                              item.imaginaryQuantityStr
                                ? item.imaginaryQuantityStr
                                : Math.floor(
                                    (item.imaginaryQuantity / 1024) * 100
                                  ) /
                                    100 +
                                  "G"
                            }}
                            <!-- 9999999999M -->
                          </span>
                          <span v-else>
                            {{
                              item.imaginaryQuantityStr
                                ? item.imaginaryQuantityStr
                                : Math.floor(
                                    (item.imaginaryQuantity / 1024) * 100
                                  ) /
                                    100 +
                                  "G"
                            }}
                            <!-- 9999999999M -->
                          </span>
                        </div>
                      </div>
                      <div style="display: flex; margin-left: 10px">
                        <div class="ax">
                          时间:
                          <span>
                            {{ item.validity }}
                            <!-- 365 -->
                            <span v-if="item.validityType == 0">天</span>
                            <span v-if="item.validityType == 1">月</span>
                            <span v-if="item.validityType == 2">年</span>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div style="margin-left: 10px">
                      <div class="ax">
                        <span style="color: red; font-size: 20px">
                          <!-- <span style="font-size: 18px"> -->

                          <div>￥{{ item.couponEndPrice }}元</div>
                          <!-- 9999999999M -->
                        </span>
                        <span
                          v-if="item.originPrice"
                          :style="{
                            color: item.originPriceColor
                              ? item.originPriceColor
                              : 'rgb(151, 144, 144)',
                            'text-decoration': 'line-through',
                          }"
                        >
                          <!-- <span style="font-size: 18px"> -->
                          ￥{{ item.originPrice }}
                          <!-- 9999999999M -->
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  (fom.couponLimit == 0 && fom.noUse > 0) ||
                  (fom.couponLimit == 1 && fom.noUse > 0 && item.type != 4)
                "
                style="
                  color: red;
                  font-size: 12px;
                  text-align: left;
                  margin-left: 5px;
                  margin-bottom: 10px;
                "
              >
                <div v-if="item.couponPrice > 0">
                  原价{{ item.price }}元。已自动使用赠送金立减{{
                    item.couponPrice
                  }}元
                </div>
              </div>
              <div style="display: flex; justify-content: space-between">
                <div
                  v-if="item.lowerLeft"
                  style="
                    display: flex;
                    vertical-align: middle;
                    margin-left: 5px;
                  "
                >
                  <img
                    src="../assets/左边.png"
                    style="width: 22px; height: 22px"
                  />
                  <span
                    :style="{
                      'font-size': '13px',
                      'margin-left': '7px',
                      color: item.lowerLeftColor
                        ? item.lowerLeftColor
                        : 'rgb(250, 176, 58)',
                    }"
                  >
                    {{ item.lowerLeft }}
                  </span>
                </div>
                <div v-else></div>
                <div
                  v-if="item.lowerRight"
                  style="display: flex; vertical-align: middle"
                >
                  <img
                    src="../assets/右边.png"
                    style="width: 22px; height: 22px"
                  />
                  <span
                    :style="{
                      'font-size': '13px',
                      'margin-left': '7px',
                      color: item.lowerRightColor
                        ? item.lowerRightColor
                        : 'rgb(255, 112, 117)',
                    }"
                  >
                    {{ item.lowerRight }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
      <van-action-sheet
        style="
          background-image: linear-gradient(to left, #198aff, #79bbff);
          color: #ffffff;
        "
        :close-on-click-overlay="false"
        :title="title"
        v-model="show"
      >
        <Tals
          :detail="detail"
          :fom="fom"
          :type="fom.seriesModel.type"
          @dateOpen="dateOpen"
          @balanceShow="balanceShow"
          @payShow="payShow"
          @planAlertse="planAlertse"
        />
      </van-action-sheet>
      <!-- 二维码 -->
      <van-action-sheet
        v-model="showss"
        cancel-text="取消"
        close-on-click-action
      >
        <img style="width: 100%" :src="imagerurl" />
        <div style="text-align: center">
          使用{{ payObj.posType == 1 ? "微信" : "支付宝" }}扫一扫打开
        </div>
      </van-action-sheet>
      <!-- 二维码 -->
      <van-action-sheet
        v-model="showsss"
        cancel-text="取消"
        close-on-click-action
      >
        <img style="width: 100%" :src="imagerurl" />
        <div style="text-align: center">
          使用{{ payShopCheck == 1 ? "微信" : "支付宝" }}扫一扫打开
        </div>
      </van-action-sheet>
      <!-- 支付商户弹窗 -->
      <van-dialog
        v-model="payObj.posShow"
        :showConfirmButton="false"
        closeOnClickOverlay
      >
        <div style="font-size: 18px; margin-top: 10px">支付金额</div>
        <div style="font-size: 20px; color: red; margin-top: 10px">
          <div>
            ￥{{
              Math.floor(
                (detail.speedShow == true
                  ? detail.couponEndPrice + payObj.vipMoney
                  : detail.couponEndPrice) * 100
              ) / 100
            }}元
          </div>
        </div>

        <div style="margin-top: 10px">
          <van-radio-group v-model="payObj.radio">
            <div
              v-for="item in payObj.newPayListItem"
              :key="item.name"
              class="content"
            >
              <div class="display-left">
                <img class="img" :src="item.imgUrl" alt="" />
                {{ item.showName }}
              </div>
              <div class="recommend">
                <div v-if="item.recommend == 1" class="recommends">推荐</div>
              </div>
              <van-radio class="display-right" :name="item.id"></van-radio>
            </div>
          </van-radio-group>
        </div>
        <div style="width: 100%">
          <van-button
            @click="confirmPay"
            size="normal"
            style="width: 80%; margin: 20px 10%; border-radius: 10px"
            type="info"
          >
            确认支付
          </van-button>
        </div>
      </van-dialog>
      <!-- 余额支付弹窗 -->
      <van-dialog
        v-model="balanceObj.show"
        :showConfirmButton="false"
        closeOnClickOverlay
      >
        <p style="font-size: 18px">支付金额</p>
        <span style="font-size: 18px; color: red">
          <div>￥{{ balanceObj.balance }}元</div>
        </span>

        <div v-if="balanceObj.type == ''" style="width: 100%; margin: 10px 0">
          <van-field
            v-model="value"
            type="number"
            style="
              width: 80%;
              background-color: #f5f5f5;
              margin: 10px 10%;
              border-radius: 10px;
            "
            placeholder="请输入支付密码"
          />
        </div>
        <div v-else style="margin-top: 10px">
          <van-radio-group v-model="payShopCheck">
            <div
              v-for="item in balanceObj.newPayList"
              :key="item.name"
              class="content"
            >
              <div class="display-left">
                <img class="img" :src="item.imageUrl" alt="" />
                {{ item.name }}
              </div>
              <div class="recommend">
                <div v-if="item.recommend == 1" class="recommends">推荐</div>
              </div>
              <van-radio class="display-right" :name="item.id"></van-radio>
            </div>
          </van-radio-group>
        </div>
        <div style="width: 100%">
          <van-button
            @click="balancePay"
            size="normal"
            style="
              width: 80%;
              margin: 10px 10%;

              border-radius: 10px;
            "
            type="info"
          >
            确认支付
          </van-button>
        </div>

        <div
          v-if="balanceObj.type == ''"
          style="
            color: red;
            font-size: 18px;
            margin: 10px 0;
            margin-bottom: 20px;
          "
        >
          默认支付密码：123456
        </div>
      </van-dialog>
      <!-- 余额支付商户弹窗 -->
      <van-dialog
        v-model="payShows"
        :showConfirmButton="false"
        closeOnClickOverlay
      >
        <div style="font-size: 18px; margin-top: 10px">支付金额</div>
        <div style="font-size: 20px; color: red; margin-top: 10px">
          <div>￥{{ balanceObj.balance }}元</div>
        </div>

        <div style="margin-top: 10px">
          <van-radio-group v-model="payShopChecks">
            <div
              v-for="item in balancePayList"
              :key="item.name"
              class="content"
            >
              <div class="display-left">
                <img class="img" :src="item.imgUrl" alt="" />
                {{ item.showName }}
              </div>
              <div class="recommend">
                <div v-if="item.recommend == 1" class="recommends">推荐</div>
              </div>
              <van-radio class="display-right" :name="item.id"></van-radio>
            </div>
          </van-radio-group>
        </div>
        <div style="width: 100%">
          <van-button
            @click="confirmPayBalance"
            size="normal"
            style="width: 80%; margin: 20px 10%; border-radius: 10px"
            type="info"
          >
            确认支付
          </van-button>
        </div>
      </van-dialog>
      <!-- 套餐营销 -->
      <van-dialog
        v-if="planAlert == true"
        v-model="planAlert"
        show-cancel-button
        confirmButtonText="充值推荐套餐"
        cancelButtonText="关闭弹窗"
        @confirm="routers(detail)"
        @cancel="cancel2(detail)"
      >
        <div
          @click="showImages($event)"
          class="titleas111111111111"
          v-html="detail.planModel.setMealMarket"
        ></div>
      </van-dialog>
      <!-- 余额营销 -->
      <van-dialog
        v-if="planAlerts == true"
        v-model="planAlerts"
        show-cancel-button
        style="overflow: auto"
        confirmButtonText="立即充值余额"
        cancelButtonText="关闭弹窗"
        @confirm="confirm1"
        @cancel="cancel1"
      >
        <div
          class="titleas"
          @click="showImages($event)"
          v-html="detail.planModel.balanceMarket"
        ></div>
      </van-dialog>
      <!-- 生效周期弹窗 -->
      <van-dialog
        v-if="dateTime.showfg"
        v-model="dateTime.showfg"
        @confirm="plmo"
        :before-close="beforeClose"
        :confirmButtonText="textb"
        confirmButtonColor="red"
        title="生效周期"
      >
        <div style="margin-top: 20px">开始时间：{{ dateTime.satrtTime }}</div>
        <div style="margin-top: 20px; margin-bottom: 20px">
          结束时间：{{ dateTime.endTime }}
        </div>
        <!-- <div style="color: red; margin-top: 20px; margin-bottom: 20px">
        谨慎订购,误订不退款
      </div> -->
      </van-dialog>
    </div>
    <!-- 跳转充值余额 -->
    <van-dialog
      v-model="banlancesaaa"
      show-cancel-button
      confirmButtonText="确认充值"
      cancelButtonText="取消"
      @confirm="confirm1"
      @cancel="banlancesaaa = false"
    >
      <div style="padding: 10px; font-size: 20px">温馨提示</div>
      <div style="padding: 10px">
        您的账户余额不足，请充值余额后再进行充值套餐充值余额有优惠哦
      </div>
    </van-dialog>
    <van-image-preview
      v-model="showImage"
      :images="[images]"
    ></van-image-preview>
  </div>
</template>
<script>
  import { sendSetMeal, addOrders, xiaoBaiYuanPay } from "@/api/newPay";
  import { Loading } from "element-ui";
  import Detail from "@/components/Detail.vue";
  import Tals from "@/views/Detail.vue";

  import {
    phoneGetMeals,
    getCategorySetMeal,
    phoneSimCard,
  } from "../api/cardOperation";

  export default {
    name: "Home",
    data() {
      return {
        showsss: false,
        payShopCheck: "",
        payShopChecks: "",
        balancePayList: [],
        payShows: false,
        times: 3,
        banlancesaaa: false,
        images: "",
        showImage: false,
        planAlerts: false,
        //二维码地址
        imagerurl: "",
        //二维码弹窗
        showss: false,
        //生效时间
        dateTime: {},
        //余额支付
        balanceObj: {},
        //余额支付金额
        value: "",
        //商户对象
        payObj: {},
        //是否传code
        code: "",
        //商户appid
        appId: "",
        fom: {},
        active: 0,
        actives: 0,
        cc: [],
        show: false,
        detail: {
          planModel: { setMealMarket: "" },
        },
        ss: "",
        s: "",
        title: "",
        dd: false,
        planAlert: false,
        textb: "请仔细査看生效时间(3s)",
        payLists: [],
        enm: "",
      };
    },
    created() {},
    mounted() {
      if (this.$route.query.code) {
        this.wx(this.$route.query.code, 0, this);
      }
      if (this.$route.query.card) {
        localStorage.setItem("meCardNum", this.$route.query.card);
      }
      this.phoneSimCard();
      this.phoneMeal();
      Loading.service();
    },
    methods: {
      //拉起支付
      xiaoBaiYuanPay(val, val1, val2, val3, val4, val5, val6) {
        xiaoBaiYuanPay(val, val1, val2, val3, val4, val5, val6).then((res) => {
          if (res.status == true) {
            if (res.data.payType == 2) {
              window.location.href = res.data.body;
            } else if (res.data.payType == 3) {
              this.show = false;
              this.imagerurl = `/app/qrcode/qrcode?content=${encodeURIComponent(
                res.data.body
              )}`;
              this.showsss = true;
            }
          } else {
            this.$toast(res.msg);
          }
        });
      },
      confirmPayBalance() {
        localStorage.removeItem("next");
        localStorage.removeItem("flag");
        localStorage.setItem("next", this.balanceObj.next);
        localStorage.setItem("flag", this.balanceObj.shows);
        localStorage.removeItem("meal");
        localStorage.setItem("meal", this.balanceObj.id);
        localStorage.removeItem("meall1");
        localStorage.setItem("meall1", this.balanceObj.balance);
        this.balancePayList.forEach((item) => {
          if (this.payShopChecks == item.id) {
            this.codes = item.code;
            this.appId = item.appId;
          }
        });
        console.log(this.payShopCheck, "看看参数");
        console.log(this.codes, "看看参数");
        console.log(this.payShopChecks, "看看参数");
        console.log(this.isWeiXin(), "看看参数");
        if (
          this.isWeiXin() == true &&
          this.codes == 0 &&
          this.payShopCheck == 1
        ) {
          this.wx(null, 1, this);
        } else {
          if (this.codes == 0) {
            this.payShows = false;
            this.imagerurl =
              window.location.protocol +
              "//" +
              window.location.host +
              `/app/qrcode/qrcode?content=${encodeURIComponent(
                `${window.location.protocol}//${
                  window.location.host
                }/wap/index.html#/wechat?balance=${
                  this.balanceObj.balance
                }&payId=${this.payShopChecks}&card=${localStorage.getItem(
                  "meCardNum"
                )}&appId=${this.appId}&balances=${1}&setMealId=${
                  this.balanceObj.id
                }&next=${this.balanceObj.next}&flag=${this.balanceObj.shows}`
              )}`;
            this.showsss = true;
          } else {
            this.payShows = false;
            this.xiaoBaiYuanPay(
              this.balanceObj.balance,
              this.payShopChecks,
              "",
              "MWEB",
              this.balanceObj.id,
              this.balanceObj.next,
              this.balanceObj.shows
            );
          }
        }
      },
      showImages(e) {
        if (e.target.tagName == "IMG") {
          this.images = e.target.src;
          this.showImage = true;
        }
      },
      planAlertse(val) {
        if (val.shows !== undefined) {
          this.detail.speedShow = val.shows;
        }
        this.planAlerts = val.show;
      },
      //支付商户弹窗
      payShow(val) {
        if (val.shows !== undefined) {
          this.detail.speedShow = val.shows;
        }
        this.show = false;
        this.payObj = val;
      },
      cancel1() {
        localStorage.setItem("balanceshow", 1);
      },
      confirm1() {
        this.$router.push(`/recharge`);
      },
      cancel2(s) {
        var price = "";
        if (s.agentSetmealModel) {
          price = s.agentSetmealModel.price;
        } else {
          price = s.price;
        }
        phoneGetMeals(s.id).then((res) => {
          if (res.status) {
            if (res.data.seriesModel.speedMembershipList) {
              if (res.data.seriesModel.speedMembershipList.length > 0) {
                res.data.speedShow = true;
                res.data.vipForm = res.data.seriesModel.speedMembershipList[0];
              }
            } else {
              res.data.speedShow = false;
            }
            if (res.data.introduce == "") {
              res.data.arr = [];
            } else {
              res.data.arr = res.data.introduce.split(/\n/g);
            }
            res.data.a = 0;
            if (res.data.validity == 30 && res.data.validityType == 0) {
              this.detail = res.data;

              this.detail.nexts = false;
              if (this.detail.seriesModel.timeAlert == 1) {
                this.detail.next = "";
              } else {
                this.detail.next = false;
              }
            } else if (res.data.next == false) {
              this.detail = res.data;
              this.detail.nexts = res.data.next;
              if (this.detail.seriesModel.timeAlert == 1) {
                this.detail.next = "";
              } else {
                this.detail.next = false;
              }
            } else {
              this.detail = res.data;
              this.detail.nexts = res.data.next;
              if (this.detail.seriesModel.timeAlert == 1) {
                this.detail.next = "";
              } else {
                this.detail.next = false;
              }
            }
            console.log("aa", this.detail);
            if (
              localStorage.getItem("next") != null &&
              localStorage.getItem("next") != undefined &&
              localStorage.getItem("next") != ""
            ) {
              if (localStorage.getItem("next") == "false") {
                this.detail.next = false;
              } else {
                this.detail.next = true;
              }
              // alert(localStorage.getItem("next"));
            }
            // this.changess();
            localStorage.removeItem("balanceshow");
            this.detail.biaoshi = 0;
            this.show = true;
          }
        });
        localStorage.removeItem("next");
        localStorage.removeItem("flag");
      },
      //余额支付
      balancePay() {
        if (this.balanceObj.type != "") {
          this.balanceObj.show = false;
          this.balanceObj.newPayList.forEach((item) => {
            if (item.id == this.payShopCheck) {
              this.payShopChecks = item.list[0].id;
              this.balancePayList = item.list;
            }
          });
          this.payShows = true;
        } else {
          if (this.value === "") {
            this.$toast.fail("密码不能为空");
          } else {
            var st = this.$toast.loading({
              message: "正在支付中，请稍后...",
              forbidClick: true,
              loadingType: "spinner",
              duration: 0,
            });
            addOrders(
              this.balanceObj.id,
              this.value,
              "",
              this.balanceObj.next == false ? 0 : 1,
              this.balanceObj.shows,
              this.balanceObj.vipId
            )
              .then((res) => {
                if (res.status) {
                  st.clear();
                  this.balanceObj.show = false;
                  // this.card = this.$route.params.card;
                  this.$dialog
                    .alert({
                      message: res.msg,
                    })
                    .then(() => {
                      // on close
                    });
                  this.value = "";
                  localStorage.removeItem("next");
                  localStorage.removeItem("flag");
                }
              })
              .catch(() => {
                st.clear();
                let s = res.msg;
                if (s == "账号余额不足") {
                  this.$dialog
                    .confirm({
                      message:
                        "账户余额小于要支付的套餐金额点击确认跳转余额充值界面",
                    })
                    .then(() => {
                      this.$router.push(`/recharge`);
                    })
                    .catch(() => {
                      // on cancel
                    });
                } else {
                  this.$dialog
                    .alert({
                      message: s,
                    })
                    .then(() => {
                      // on close
                    });
                }
                localStorage.removeItem("next");
                localStorage.removeItem("flag");
              });
          }
        }
      },
      //拉起支付
      sendSetMeal(mealId, payId, code, next, payType, val, vipId) {
        sendSetMeal(mealId, payId, code, next, payType, val, vipId).then(
          (res) => {
            if (res.status) {
              if (res.data.payType == 2) {
                window.location.href = res.data.body;
              } else if (res.data.payType == 3) {
                console.log(res.data.body);
                this.imagerurl = `/app/qrcode/qrcode?content=${encodeURIComponent(
                  res.data.body
                )}`;
                console.log(this.imagerurl);
                this.payObj.posShow = false;
                this.showss = true;
              }
            } else {
              this.$toast(res.msg);
            }
          }
        );
      },
      //确认支付
      confirmPay() {
        localStorage.removeItem("next");
        localStorage.removeItem("flag");
        localStorage.setItem("next", this.payObj.next);
        localStorage.setItem("flag", this.payObj.shows);
        localStorage.removeItem("meal");
        localStorage.setItem("meal", this.payObj.id);
        localStorage.removeItem("vipId");
        localStorage.setItem("vipId", this.payObj.vipId);
        this.payObj.newPayListItem.forEach((item) => {
          if (this.payObj.radio == item.id) {
            this.codes = item.code;
            this.appId = item.appId;
          }
        });

        if (
          this.isWeiXin() == true &&
          this.codes == 0 &&
          this.payObj.posType == 1
        ) {
          this.wx(null, 1, this);
        } else {
          if (this.codes == 0) {
            this.payObj.posShow = false;
            this.imagerurl =
              window.location.protocol +
              "//" +
              window.location.host +
              `/app/qrcode/qrcode?content=${encodeURIComponent(
                `${window.location.protocol}//${
                  window.location.host
                }/wap/index.html#/wechat?mealId=${this.payObj.id}&payId=${
                  this.payObj.radio
                }&card=${localStorage.getItem("meCardNum")}&appId=${
                  this.appId
                }&next=${this.payObj.next}&flag=${this.payObj.shows}&vipId=${
                  this.payObj.vipId
                }&meal=${1}`
              )}`;
            this.showss = true;
          } else {
            this.sendSetMeal(
              this.payObj.id,
              this.payObj.radio,
              "",
              this.payObj.next,
              "MWEB",
              this.payObj.shows,
              this.payObj.vipId
            );
          }
        }
      },
      //余额支付弹窗
      balanceShow(val) {
        this.show = false;
        this.value = "";
        this.balanceObj = val;
        this.payShopCheck = this.balanceObj.newPayList[0].id;
      },
      //子组件获取生效时间
      dateOpen(val) {
        this.dateTime.plok = 0;
        this.times = 3;
        this.dateTime = val;
        const interval = setInterval(() => {
          if (this.times > 0) {
            this.times--;
            this.textb = "请仔细査看生效时间(" + this.times + "s)";
          } else {
            this.textb = "已确认时间";
            clearInterval(interval);
          }
        }, 1000);
      },
      //已知晓生效时间
      plmo() {
        if (this.times <= 0) {
          this.dateTime.showfg = false;
          this.times = 0;
          this.textb = "请仔细査看生效时间(3s)";
          this.dateTime.plok = 1;
        }
      },
      beforeClose(action, done) {
        if (action === "confirm" && this.times > 0) {
          return done(false);
        } else {
          this.dateTime.showfg = false;
          this.dateTime.plok = 1;
        }
      },
      isWeiXin() {
        var ua = navigator.userAgent.toLowerCase();
        // console.log(ua)
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          return (this.qqs = true);
        } else {
          return (this.qqs = false);
        }
      },
      weixinSDK(appid, timeStamp, package2, nonceStr, paySign, type, payType) {
        function onBridgeReady() {
          window.WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: appid,
              timeStamp: timeStamp,
              nonceStr: nonceStr,
              package: package2,
              signType: type,
              paySign: paySign,
              payType: payType,
            },
            function (res) {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                alert("充值成功");
              } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                alert("取消充值");
              } else if (res.err_msg == "get_brand_wcpay_request:fail") {
                alert("充值失败");
              }
            }
          );
        }

        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              onBridgeReady,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
            document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
          }
        } else {
          onBridgeReady();
        }
      },
      wx(code, type, than) {
        function jumpLink() {
          //       window.location="https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + that.appId +
          //       "&redirect_uri=" + window.location.protocol + '//' + window.location.host +
          // "&response_type=code&scope=snsapi_userinfo&state=" + time + "#wechat_redirect";''
          var url = "";
          if (than.payShopCheck !== "") {
            url = encodeURIComponent(
              window.location.protocol +
                "//" +
                window.location.host +
                "/appRedirect/" +
                `?card=${localStorage.getItem("meCardNum")}&payId=${
                  than.payShopChecks
                }&next=${localStorage.getItem(
                  "next"
                )}&flags=${localStorage.getItem(
                  "flag"
                )}&vipId=${localStorage.getItem(
                  "vipId"
                )}&balance=${localStorage.getItem(
                  "meall1"
                )}&recharge=${1}&routeAddress=${encodeURIComponent(
                  "/wap/index.html#/about"
                )}`
            );
          } else {
            url = encodeURIComponent(
              window.location.protocol +
                "//" +
                window.location.host +
                "/appRedirect/" +
                `?card=${localStorage.getItem("meCardNum")}&payId=${
                  than.payObj.radio
                }&next=${localStorage.getItem(
                  "next"
                )}&flags=${localStorage.getItem(
                  "flag"
                )}&vipId=${localStorage.getItem(
                  "vipId"
                )}&biaoShi=${1}&recharge=${1}&routeAddress=${encodeURIComponent(
                  "/wap/index.html#/about"
                )}`
            );
          }

          // alert(than.detail.next);
          // than.detail.next = localStorage.getItem("next");
          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            than.appId +
            "&response_type=code&scope=snsapi_userinfo&redirect_uri=" +
            url;
          // alert(localStorage.getItem("next"));
          // than.detail.next = localStorage.getItem("next");
        }

        getUserInfo();

        function getUserInfo() {
          if (
            code != null &&
            code != undefined &&
            code.trim() != "" &&
            than.$route.query.biaoShi
          ) {
            var s = "";
            if (than.isWeiXin() == true) {
              s = "JSAPI";
            } else {
              s = "MWEB";
            }
            sendSetMeal(
              Number(localStorage.getItem("meal")),
              than.$route.query.payId,
              code,
              than.$route.query.next,
              s,
              localStorage.getItem("flag"),
              localStorage.getItem("vipId")
            ).then((res) => {
              if (res.status) {
                var obj = {};
                obj = res.data.body;

                than.weixinSDK(
                  obj.appId,
                  obj.timeStamp,
                  obj.package,
                  obj.nonceStr,
                  obj.sign,
                  obj.signType,
                  s
                );
              } else {
                than.$toast(res.msg);
              }
            });
          } else if (
            code != null &&
            code != undefined &&
            code.trim() != "" &&
            than.$route.query.recharge
          ) {
            var s = "";
            if (than.isWeiXin() == true) {
              s = "JSAPI";
            } else {
              s = "MWEB";
            }
            xiaoBaiYuanPay(
              than.$route.query.balance,
              than.$route.query.payId,
              code,
              s,
              Number(localStorage.getItem("meal")),
              than.$route.query.next,
              localStorage.getItem("flag")
            ).then((res) => {
              if (res.status) {
                var obj = {};
                obj = res.data.body;

                than.weixinSDK(
                  obj.appId,
                  obj.timeStamp,
                  obj.package,
                  obj.nonceStr,
                  obj.sign,
                  obj.signType,
                  s
                );
              } else {
                than.$toast(res.msg);
              }
            });
          }
          {
            if (type == 1) {
              jumpLink();
            }
          }
        }
      },
      sqwes(name) {
        console.log(name);
      },
      routers(s) {
        var price = "";
        if (s.agentSetmealModel) {
          price = s.agentSetmealModel.price;
        } else {
          price = s.price;
        }
        phoneGetMeals(s.planModel.appointSetMealId).then((res) => {
          if (res.status) {
            res.data.isRead = false;
            if (res.data.seriesModel.speedMembershipList) {
              if (res.data.seriesModel.speedMembershipList.length > 0) {
                res.data.speedShow = true;
                res.data.vipForm = res.data.seriesModel.speedMembershipList[0];
              }
            } else {
              res.data.speedShow = false;
            }
            if (res.data.introduce == "") {
              res.data.arr = [];
            } else {
              res.data.arr = res.data.introduce.split(/\n/g);
            }
            res.data.a = 0;
            if (res.data.validity == 30 && res.data.validityType == 0) {
              this.detail = res.data;

              this.detail.nexts = false;
              if (this.detail.seriesModel.timeAlert == 1) {
                this.detail.next = "";
              } else {
                this.detail.next = false;
              }
            } else if (res.data.next == false) {
              this.detail = res.data;
              this.detail.nexts = res.data.next;
              if (this.detail.seriesModel.timeAlert == 1) {
                this.detail.next = "";
              } else {
                this.detail.next = false;
              }
            } else {
              this.detail = res.data;
              this.detail.nexts = res.data.next;
              if (this.detail.seriesModel.timeAlert == 1) {
                this.detail.next = "";
              } else {
                this.detail.next = false;
              }
            }
            console.log("aa", this.detail);
            if (
              localStorage.getItem("next") != null &&
              localStorage.getItem("next") != undefined &&
              localStorage.getItem("next") != ""
            ) {
              if (localStorage.getItem("next") == "false") {
                this.detail.next = false;
              } else {
                this.detail.next = true;
              }
              // alert(localStorage.getItem("next"));
            }
            // this.changess();
            localStorage.removeItem("balanceshow");
            this.detail.biaoshi = 0;
            this.show = true;
          }
        });
        localStorage.removeItem("next");
        localStorage.removeItem("flag");
      },

      router(s) {
        this.payShopCheck == "";
        this.payShopChecks == "";
        var price = "";
        if (s.agentSetmealModel) {
          price = s.agentSetmealModel.price;
        } else {
          price = s.price;
        }
        // if (s.balancePayment == 1 && this.fom.balance < s.couponEndPrice) {
        //   this.banlancesaaa = true;
        // } else {
        phoneGetMeals(s.id).then((res) => {
          if (res.status) {
            res.data.isRead = true;
            if (res.data.seriesModel.speedMembershipList) {
              if (res.data.seriesModel.speedMembershipList.length > 0) {
                res.data.speedShow = true;
                res.data.vipForm = res.data.seriesModel.speedMembershipList[0];
              }
            } else {
              res.data.speedShow = false;
            }

            if (res.data.introduce == "") {
              res.data.arr = [];
            } else {
              res.data.arr = res.data.introduce.split(/\n/g);
            }
            res.data.a = 0;
            res.data.cardBalance = this.fom.balance;
            if (res.data.validity == 30 && res.data.validityType == 0) {
              this.detail = res.data;

              this.detail.nexts = false;
              if (this.detail.seriesModel.timeAlert == 1) {
                this.detail.next = "";
              } else {
                this.detail.next = false;
              }
            } else if (res.data.next == false) {
              this.detail = res.data;
              this.detail.nexts = res.data.next;
              if (this.detail.seriesModel.timeAlert == 1) {
                this.detail.next = "";
              } else {
                this.detail.next = false;
              }
            } else {
              this.detail = res.data;
              this.detail.nexts = res.data.next;
              if (this.detail.seriesModel.timeAlert == 1) {
                this.detail.next = "";
              } else {
                this.detail.next = false;
              }
            }
            console.log("aa", this.detail);
            if (
              localStorage.getItem("next") != null &&
              localStorage.getItem("next") != undefined &&
              localStorage.getItem("next") != ""
            ) {
              if (localStorage.getItem("next") == "false") {
                this.detail.next = false;
              } else {
                this.detail.next = true;
              }
              // alert(localStorage.getItem("next"));
            }
            // this.changess();
            localStorage.removeItem("balanceshow");
            if (this.detail.seriesModel.prestore == true) {
              if (this.fom.balance < s.couponEndPrice) {
                this.$dialog
                  .confirm({
                    message:
                      "账户余额小于要支付的套餐金额点击确认跳转余额充值界面",
                  })
                  .then(() => {
                    this.$router.push(`/recharge`);
                  })
                  .catch(() => {
                    // on cancel
                  });
              } else {
                this.detail.biaoshi = 0;
                this.show = true;
              }
            } else {
              if (this.detail.planAlert == true) {
                this.planAlert = this.detail.planAlert;
              } else {
                this.detail.biaoshi = 0;
                this.show = true;
              }
            }
          }
        });
        localStorage.removeItem("next");
        localStorage.removeItem("flag");
        // }
      },

      phoneMeal() {
        this.cc = [];
        getCategorySetMeal().then((res) => {
          if (res.status) {
            res.data.forEach((item) => {
              if (item.setMealModels.length > 0) {
                this.cc.push(item);
              }
            });
          }
        });
      },
      phoneSimCard() {
        phoneSimCard().then((res) => {
          if (res.status) {
            this.fom = res.data;
            this.title = "卡号：" + localStorage.getItem("meCardNum");
            console.log(this.fom);
            Loading.service().close();
            this.dd = true;
          } else {
            this.$toast(res.msg);
            Loading.service().close();
          }
        });
      },
    },
    components: {
      Detail,
      Tals,
    },
  };
</script>
<style lang="scss">
  .titleas111111111111 {
    max-height: 360px;
    overflow: auto;
    margin: 10px 10px;
    text-align: left;
    p {
      img {
        width: 100%;
      }
    }
  }
</style>
<style scoped lang="scss">
  .recommend {
    display: flex;
    align-items: center;
    width: 27px;
  }

  .recommends {
    background: #ffca66;
    color: #ffffff;
    width: 27px;
    text-align: center;
    font-size: 9px;
    height: 15px;
    border-radius: 3px;
  }

  .content {
    display: flex;
    justify-content: space-between;
    width: 100%;
    background-color: white;
    padding: 10px;
    color: black;
    font-size: 16px;
    box-sizing: border-box;
    border-top: 1px solid rgba(#009fff, 0.2);
    border-bottom: 1px solid rgba(#009fff, 0.2);
  }

  .img {
    width: 22px;
    height: 22px;
    vertical-align: middle;
  }

  .display-left {
    width: 50%;
    text-align: left;
    // display: flex;
    align-items: left;
    justify-self: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .display-right {
    display: flex;
    align-items: center;
    width: 35%;
    justify-content: flex-end;
    margin-right: 5%;
  }

  .about {
    padding: 5%;
  }

  .tuijian {
    position: absolute;
    top: 0px;
    right: 0px;
    background-image: linear-gradient(#f87b62, #ff3c00);
    height: 25px;
    line-height: 25px;
    text-align: center;
    padding: 0 5px;
    border-radius: 0 9px 0 9px;
    color: white;
  }

  .taocan {
    width: 100%;
    border-radius: 10px;
    padding: 5px;
    box-sizing: border-box;
    padding-bottom: 15px;
    margin-top: 20px;
    background-color: white;

    border: 1px solid #c5e1ff;
  }

  .aq {
    background: #feedd9;
    border: 1px solid #e78009;
  }

  .op {
    opacity: 100%;
  }

  .ax {
    margin-bottom: 5px;
    margin-left: 5px;
    font-size: 13px;
    line-height: 20px;
    text-align: center;

    color: rgba(128, 128, 128, 1);
  }
</style>
